import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const AdkCalculusTable = ({ params, report, }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head params={params} />
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkCalculusTable;



// WEBPACK FOOTER //
// ./src/scenes/AdkCalculus/components/Table/index.js